// import React, { useEffect, useState } from "react";
// import { Button, Modal } from "react-bootstrap";
// import { useNavigate, useLocation } from "react-router-dom";
// import Commonheader from "../CommonUtils/Commonheader";
// import "../index.css";

// import { IoDocumentText, IoHomeSharp } from "react-icons/io5";
// import { FaDatabase } from "react-icons/fa";

// import * as FiIcons from "react-icons/fi";
// import * as HiIcons from "react-icons/hi";
// import * as FaIcons from "react-icons/fa";
// import * as IoIcons from "react-icons/io5";
// import { MdEditDocument } from "react-icons/md";
// import ChangePassword from "../ChangePassword";


// const getIcon = (iconName) => {
//   if (!iconName) return null;
//   const name = iconName.trim();
//   return FiIcons[name] || HiIcons[name] || FaIcons[name] || IoIcons[name] || null;
// };

// function ParentSection({ parent, kids, activeMenu, onSelect, sidebarOpen }) {

//   const [open, setOpen] = useState(false);

//   const hasActiveChild = kids.some((k) => k.service_name === activeMenu);

//   useEffect(() => {
//     if (hasActiveChild) {
//       setOpen(true);   // open only when child is active
//     }
//   }, [hasActiveChild]);

//   const ParentIcon = getIcon(parent.icon) || IoDocumentText;

//   return (
//     <li className="parent-menu">

//       <div
//         className={`parent-title ${hasActiveChild ? "parent-has-active" : ""}`}
//         role="button"
//         tabIndex={0}
//         onClick={() => setOpen(!open)}
//         onKeyDown={(e) => {
//           if (e.key === "Enter" || e.key === " ") {
//             e.preventDefault();
//             setOpen(!open);
//           }
//         }}
//       >
//         <div className="parent-icon">
//           {sidebarOpen && (
//             <>
//               <ParentIcon size={16} className="me-2" />
//               <span>{parent.display_name}</span>
//             </>
//           )}
//         </div>

//         {!sidebarOpen && (
//           <span title={parent.display_name}>
//             <ParentIcon size={16} />
//           </span>
//         )}

//         {sidebarOpen && (
//           <span className="parent-arrow">{open ? "▾" : "▸"}</span>
//         )}
//       </div>

//       {open && (
//         <div className="children-wrapper">
//           {kids.map((child) => {

//             const ChildIcon = getIcon(child.icon) || FaDatabase;

//             return (
//               <div
//                 key={child.service_id}
//                 className={`child-item ${activeMenu === child.service_name ? "active" : ""}`}
//                 role="button"
//                 tabIndex={0}
//                 onClick={() => onSelect(child.service_name)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     onSelect(child.service_name);
//                   }
//                 }}
//               >
//                 <ChildIcon size={16} className="me-2" />
//                 <span className="child-itemnew">{child.display_name}</span>
//               </div>
//             );
//           })}
//         </div>
//       )}

//     </li>
//   );
// }
// export function MenuBar({ children }) {

//   const navigate = useNavigate();
//   const location = useLocation();

//   const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

//   const currentPath = location.pathname.replace("/", "") || "home";
//   const [activeMenu, setActiveMenu] = useState(currentPath);

//   const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];
//   const isChanged = sessionStorage.getItem("is_changed");

//   const filtered = menuData.filter(
//     (item) =>
//       item.service_name?.toLowerCase() !== "home" &&
//       item.display_name?.toLowerCase() !== "home"
//   );

//   const sorted = [...filtered].sort((a, b) => a.order_by - b.order_by);

//   const parents = sorted.filter((item) => item.parent_id === null);
//   const kids = sorted.filter((item) => item.parent_id !== null);

//   const hasHierarchy = parents.length > 0 && kids.length > 0;


//   useEffect(() => {

//     navigate("/home", { replace: true });
//     setActiveMenu("home");

//   }, []);


//   useEffect(() => {

//     const path = location.pathname.replace("/", "") || "home";
//     setActiveMenu(path);

//   }, [location.pathname]);


//   useEffect(() => {

//     const onResize = () => setSidebarOpen(window.innerWidth > 768);

//     window.addEventListener("resize", onResize);

//     return () => window.removeEventListener("resize", onResize);

//   }, []);


//   const handleSelect = (serviceName) => {

//     setActiveMenu(serviceName);
//     navigate(`/${serviceName}`);

//   };


//   const [modal, setModal] = useState(false);

//   useEffect(() => {

//     if (isChanged !== true) // NOSONAR
//       setModal(true);

//   }, [isChanged]);


//   if (!menuData.length) return null;


//   return (
//     <>
//       <Commonheader />
//       <Modal
//         show={modal}
//         onHide={() => setModal(false)}
//         size="lg"
//         centered
//         backdrop="static"
//         keyboard={false}
//         animation={false}
//         className='chage-passmodal'
//       >
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Change Password</Modal.Title> */}
//         </Modal.Header>

//         <Modal.Body>
//           <ChangePassword />
//         </Modal.Body>
//         <Modal.Footer>
//           <div className="d-flex flex-row justify-content-end">

//             <button type="submit" className="btn btn-primary btn-sm submit-btn border-0 modal-footbtn" >
//               Reset Password
//             </button>
//             <button type="button" className="btn btn-danger btn-sm border-0 modal-footbtn">
//               Close
//             </button>


//           </div>
//         </Modal.Footer>
//       </Modal>


//       <div className="dashboard-container vh-100">

//         <div className="main-area">

//           <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>

//             <Button
//               className="toggle-btn"
//               onClick={() => setSidebarOpen(!sidebarOpen)}
//             >

//               {sidebarOpen ? (

//                 <img
//                   src="../images/toggle1.svg"
//                   className="img-fluid toggle1"
//                   alt="toggle1"
//                 />

//               ) : (

//                 <img
//                   src="../images/toggle2.svg"
//                   className="img-fluid toggle2"
//                   alt="toggle2"
//                 />

//               )}

//             </Button>


//             <ul className="sidebar-menu">

//               <li
//                 className={`single-menu home-menu ${activeMenu === "home" ? "active" : ""}`}
//                 role="button"
//                 tabIndex={0}
//                 onClick={() => handleSelect("home")}
//                 onKeyDown={(e) => {

//                   if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     handleSelect("home");
//                   }

//                 }}
//               >

//                 <IoHomeSharp />
//                 <span className="child-itemnew">Home</span>

//               </li>


//               {hasHierarchy
//                 ?

//                 // parents.map((parent) => {

//                 //     const parentKids = kids
//                 //         .filter((c) => c.parent_id === parent.service_id)
//                 //         .sort((a, b) => a.order_by - b.order_by);

//                 //     return (

//                 //         <ParentSection
//                 //             key={parent.service_id}
//                 //             parent={parent}
//                 //             kids={parentKids}
//                 //             activeMenu={activeMenu}
//                 //             onSelect={handleSelect}
//                 //             sidebarOpen={sidebarOpen}
//                 //         />

//                 //     );

//                 // })
//                 parents.map((parent) => {

//                   const parentKids = kids
//                     .filter((c) => c.parent_id === parent.service_id)
//                     .sort((a, b) => a.order_by - b.order_by);

//                   const ParentIcon = getIcon(parent.icon) || MdEditDocument;

//                   // 🔹 Parent WITH children → dropdown
//                   if (parentKids.length > 0) {
//                     return (
//                       <ParentSection
//                         key={parent.service_id}
//                         parent={parent}
//                         kids={parentKids}
//                         activeMenu={activeMenu}
//                         onSelect={handleSelect}
//                         sidebarOpen={sidebarOpen}
//                       />
//                     );
//                   }

//                   // 🔹 Parent WITHOUT children → direct route
//                   return (
//                     <li
//                       key={parent.service_id}
//                       className={`single-menu ${activeMenu === parent.service_name ? "active" : ""}`}
//                       role="button"
//                       tabIndex={0}
//                       onClick={() => handleSelect(parent.service_name)}
//                       onKeyDown={(e) => {
//                         if (e.key === "Enter" || e.key === " ") {
//                           e.preventDefault();
//                           handleSelect(parent.service_name);
//                         }
//                       }}
//                     >
//                       <ParentIcon size={16} className="me-2" />
//                       {sidebarOpen && <span>{parent.display_name}</span>}
//                     </li>
//                   );
//                 })

//                 :

//                 sorted.map((item) => {

//                   const ItemIcon = getIcon(item.icon) || MdEditDocument;

//                   return (

//                     <li
//                       key={item.service_id}
//                       className={`single-menu ${activeMenu === item.service_name ? "active" : ""}`}
//                       role="button"
//                       tabIndex={0}
//                       onClick={() => handleSelect(item.service_name)}
//                       onKeyDown={(e) => {

//                         if (e.key === "Enter" || e.key === " ") {
//                           e.preventDefault();
//                           handleSelect(item.service_name);
//                         }

//                       }}
//                     >

//                       <ItemIcon size={16} className="me-2" />
//                       {sidebarOpen && <span>{item.display_name}</span>}

//                     </li>

//                   );

//                 })
//               }

//             </ul>


//             <div className="sidebar-footer">

//               <p className="mb-0">
//                 Powered By{" "}
//                 <a href="https://apcfss.in/" target="_blank" rel="noreferrer">
//                   <img
//                     src="../images/dashboard-footer.png"
//                     alt=""
//                     className="img-fluid"
//                   />
//                 </a>
//               </p>

//             </div>

//           </aside>


//           <main className="content-box">

//             <div className="inner-content">
//               {children}
//             </div>

//           </main>

//         </div>

//       </div>
//     </>
//   );
// }

// export default MenuBar;

import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import Commonheader from "../CommonUtils/Commonheader";
import "../index.css";
import { IoHomeSharp } from "react-icons/io5";
import { MdEditDocument } from "react-icons/md";
import ChangePassword from "../ChangePassword";
import { getIcon, ParentSection, MenuItem } from "./ParentSection";

export function MenuBar({ children }) {

  const navigate = useNavigate();
  const location = useLocation();

  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

  const currentPath = location.pathname.replace("/", "") || "home";
  const [activeMenu, setActiveMenu] = useState(currentPath);

  const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];
  const isChanged = sessionStorage.getItem("is_changed");

  const filtered = menuData.filter(
    (item) =>
      item.service_name?.toLowerCase() !== "home" &&
      item.display_name?.toLowerCase() !== "home"
  );

  const sorted = [...filtered].sort((a, b) => a.order_by - b.order_by);

  const parents = sorted.filter((item) => item.parent_id === null);
  const kids = sorted.filter((item) => item.parent_id !== null);

  const hasHierarchy = parents.length > 0 && kids.length > 0;

  useEffect(() => {
    navigate("/home", { replace: true });
    setActiveMenu("home");
  }, []);

  useEffect(() => {
    const path = location.pathname.replace("/", "") || "home";
    setActiveMenu(path);
  }, [location.pathname]);

  useEffect(() => {
    const onResize = () => setSidebarOpen(window.innerWidth > 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleSelect = (serviceName) => {
    setActiveMenu(serviceName);
    navigate(`/${serviceName}`);
  };

  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (isChanged !== true) // NOSONAR
      setModal(true);
  }, [isChanged]);

  if (!menuData.length) return null;

  // ── Build menu items ────────────────────────────────────────────────────────
  const menuItems = hasHierarchy
    ? parents.map((parent) => ({
      item: parent,
      kids: kids
        .filter((c) => c.parent_id === parent.service_id)
        .sort((a, b) => a.order_by - b.order_by),
    }))
    : sorted.map((item) => ({ item, kids: [] }));

  return (
    <>
      <Commonheader />



      <Modal
        show={modal}
        onHide={() => setModal(false)}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        animation={false}
        className="chage-passmodal"
      >
        <Modal.Body>
          <ChangePassword closeModal={() => setModal(false)} />
        </Modal.Body>
        {/* <Modal.Footer>
          <div className="d-flex flex-row justify-content-end">
            <button type="submit" className="btn btn-primary btn-sm submit-btn border-0 modal-footbtn">
              Reset Password
            </button>

          </div>
        </Modal.Footer> */}
      </Modal>

      <div className="dashboard-container vh-100">
        <div className="main-area">
          <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>

            <Button
              className="toggle-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              {sidebarOpen ? (
                <img src="../images/toggle1.svg" className="img-fluid toggle1" alt="toggle1" />
              ) : (
                <img src="../images/toggle2.svg" className="img-fluid toggle2" alt="toggle2" />
              )}
            </Button>

            <ul className="sidebar-menu">

              {/* Home - always shown */}
              <li
                className={`single-menu home-menu ${activeMenu === "home" ? "active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => handleSelect("home")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleSelect("home");
                  }
                }}
              >
                <IoHomeSharp />
                <span className="child-itemnew">Home</span>
              </li>

              {/* Dynamic menu items */}
              {menuItems?.map(({ item, kids }) => (
                <MenuItem
                  key={item.service_id}
                  item={item}
                  kids={kids}
                  activeMenu={activeMenu}
                  onSelect={handleSelect}
                  sidebarOpen={sidebarOpen}
                  defaultIcon={MdEditDocument}
                />
              ))}

            </ul>

            <div className="sidebar-footer">
              <p className="mb-0">
                Powered By{" "}
                <a href="https://apcfss.in/" target="_blank" rel="noreferrer">
                  <img src="../images/dashboard-footer.png" alt="" className="img-fluid" />
                </a>
              </p>
            </div>

          </aside>

          <main className="content-box">
            <div className="inner-content">
              {children}
            </div>
          </main>

        </div>
      </div>
    </>
  );
}

export default MenuBar;
